import { Component, OnInit } from '@angular/core';
import { Validators } from '@angular/forms';
import { FormGroup, FormControl } from '@angular/forms';

import {ApiService} from "../api.service";
import { HttpErrorResponse} from '@angular/common/http';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  providers: [ApiService],
  styleUrls: ['./login.component.sass']
})
export class LoginComponent implements OnInit {

    form = new FormGroup({
        email: new FormControl('', [Validators.required, Validators.email]),
        password: new FormControl('', [Validators.required, Validators.minLength(4)])
    });

    constructor(private apiService: ApiService) { }

  ngOnInit() {
  }

    onSubmit() {
        console.log("Login clicked");
        if(!this.form.valid) {
            return;
        };
        this.apiService.loginEmail(this.form.value.email, this.form.value.password)
                        .subscribe(resp => {console.log("Response:",resp);}, error => {
                            console.log("Error:", error);
                            if( error instanceof HttpErrorResponse) {
                                if (error.status == 404) {
                                    this.form.controls['email'].setErrors({'notFound': true});
                                }
                                if (error.status == 403) {
                                    this.form.controls['password'].setErrors({'passwordWrong': true});
                                }
                            }});
    }

}
